import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const categoriesData = [
    { id: 1, title: 'Ertiga ', image: '/images/ourfleet/11.jpg' },
    { id: 1, title: 'Swift Dezire', image: '/images/ourfleet/22.jpg' },
    { id: 1, title: ' Aura', image: '/images/ourfleet/33.jpg' },
    { id: 1, title: ' Kia Carence', image: '/images/ourfleet/44.jpg' },

];

const CategorySection = () => {
    const settings = {
        dots: true,                  // Enable navigation dots
        infinite: true,              // Infinite loop for slides
        speed: 500,                  // Transition speed
        autoplay: true,              // Enable autoplay
        autoplaySpeed: 3000,         // Slide change time interval (3 seconds)
        slidesToShow: 4,             // Show 4 images per slide
        slidesToScroll: 1,           // Scroll 1 image at a time
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,     // Show 3 images for medium screens
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,     // Show 1 image for small screens
                    slidesToScroll: 1,
                }
            }
        ]
    };

    return (
        <section className="category-section centred container-fluid py-4">
            <div className="auto-container">
                <div className="sec-title mb_50">
                    <span className="sub-title">Lets Go With Us!</span>
                    <h2>Choose Your preferred Ride!</h2>
                </div>
                <Slider {...settings}>
                    {categoriesData.map(category => (
                        <div className="category-block-one borderr" key={category.id}>
                            <div className="inner-box">
                                <figure className="image-box">
                                    <img src={category.image} alt={category.title} />
                                </figure>
                                <h4><a href="" className='darkcolorr'>{category.title}</a></h4>
                            </div>
                        </div>
                    ))}
                </Slider>
            </div>
        </section>
    );
};

export default CategorySection;
